'use client';

import React from 'react';
import { Button } from '../ui/button/button';
import { Notfound } from '@/icons/iconsComponent';
import Link from 'next/link';

const NotFound = () => {
  const goBack = () => {
    window.history.back();
  };

  return (
    <div className='flex w-full flex-col items-center justify-center h-[95vh] gap-y-2'>
      <p className='h1 text-pics'> 404</p>
      <Notfound className='text-pics' />
      <div className='body-12-regular'> صفحه مورد نظر یافت نشد.</div>
      <Button
        variant='link'
        className='flex flex-row gap-x-2 items-center cursor-pointer hover:text-blue-1-hover'
        onClick={goBack}
      >
        <p className='body-12-bold'>بازگشت به صفحه قبل </p>
      </Button>
      <Button>
        <Link href={'/'}> رفتن به داشبورد</Link>
      </Button>
    </div>
  );
};

export default NotFound;
